import * as CryptoJS from 'crypto-js';

export const createSHA256Hash = (string: string, secretKey: string): string => {
  try {
    return CryptoJS.HmacSHA256(string, secretKey).toString();
  } catch (e) {
    return string;
  }
};
